export default ({ item: { label, value = false } }) => (
  <div className="flex items-center gap-1">
    <div className={`checkbox-like badge ${value ? 'badge-primary' : 'badge-outline opacity-80'} badge-sm mr-1`}>
      {value ? '✓' : '' }
    </div>
    <span className={value ? 'font-medium' : 'text-gray-700'}>{label}</span>
  </div>
)